import React from 'react';
import { cn } from '../../lib/utils';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'cyan' | 'purple' | 'emerald' | 'gradient';
}

export function FancySpinner({ size = 'md', variant = 'gradient', className, ...props }: SpinnerProps) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
    xl: 'w-16 h-16 border-4',
  };

  const variantClasses = {
    cyan: 'border-cyan-500/20 border-t-cyan-500 shadow-[0_0_15px_rgba(6,182,212,0.5)]',
    purple: 'border-purple-500/20 border-t-purple-500 shadow-[0_0_15px_rgba(168,85,247,0.5)]',
    emerald: 'border-emerald-500/20 border-t-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.5)]',
    gradient: 'border-blue-500/20 border-t-cyan-400 border-r-purple-500 shadow-[0_0_20px_rgba(56,189,248,0.4)]',
  };

  return (
    <div className="relative inline-flex items-center justify-center" {...props}>
      <div
        className={cn(
          'rounded-full animate-spin transition-all duration-300',
          sizeClasses[size],
          variantClasses[variant],
          className
        )}
      />
      <div
        className={cn(
          'absolute rounded-full animate-ping opacity-25',
          size === 'sm' && 'w-3 h-3 bg-cyan-400',
          size === 'md' && 'w-5 h-5 bg-cyan-400',
          size === 'lg' && 'w-8 h-8 bg-purple-500',
          size === 'xl' && 'w-10 h-10 bg-purple-500'
        )}
      />
    </div>
  );
}

export function PulseWaveLoader({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center justify-center space-x-2 py-4', className)}>
      {[0, 150, 300].map((delay, idx) => (
        <div
          key={idx}
          className="w-3 h-3 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 animate-bounce"
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </div>
  );
}
